import API from "..";
import { API_POSITION_IMPORT } from "../../constants/api";

async function importPositions(data) {
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  try {
    const response = await API.post(API_POSITION_IMPORT, data, {
      headers,
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { importPositions };
